import { defineComponent as _defineComponent } from 'vue'
import { User } from "@/CodegenTypes";

import { getDownlinesTreeForTreeTable } from "@/helpers/downline/getDownlinesTreeForTreeTable";
import { getDownlinesTree } from "@/helpers/downline/getDownlinesTree";
import { queries } from "@/apollo";
import { computed, ref } from "vue";
import { useQuery } from "@vue/apollo-composable";
import { useRootStore } from "@/store/pinia";
import { useRoute, useRouter } from "vue-router/composables";
import { useTranslation } from "@/store/translation";


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountSelectModal',
  props: {
    userId: null,
    value: { type: Boolean },
    header: null
  },
  emits: ["input", "update:userId"],
  setup(__props: any, { emit }: { emit: ({
  (e: "input", val: boolean): void;
  (e: "update:userId", userId: User["userId"]): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  userId?: User["userId"];
  value: boolean;
  header?: string;
};



const rootStore = useRootStore();
const { $t } = useTranslation();

const userId = computed(() => props.userId ?? rootStore.account?.userId);

const route = useRoute();
const router = useRouter();

const searchInput = ref(null);

const filterTerm = ref("");

const { result, loading } = useQuery<{ me: User }>(
  queries.meWithAllDownlines,
  {},
  {
    fetchPolicy: "cache-and-network",
  }
);

const expandedKeys = ref<{ [userId: string]: boolean }>({
  [useRootStore().account!.userId]: true,
});



const accountNodes = computed(() => {
  if (!result.value?.me) {
    return [];
  }

  if (!filterTerm.value) {
    const downlineTree = getDownlinesTree(
      result.value?.me,
      result.value?.me.downlines
    );
    return [getDownlinesTreeForTreeTable(downlineTree)];
  } else {
    const downlines = result.value?.me.downlines;
    return [result.value?.me, ...downlines]
      .filter(
        (user) =>
          user.userId.includes(filterTerm.value.toLowerCase()) ||
          user.username.toLowerCase().includes(filterTerm.value.toLowerCase())
      )
      .map((user) => ({
        result: user.userId,
        key: user.userId,
        label: `${user.userId.toUpperCase()} (${user.username})`,
      }));
  }
});

function collapseAll() {
  expandedKeys.value = {};
}
function expandAll() {
  if (!result.value?.me) {
    return;
  }
  const downlines = result.value?.me.downlines;
  const userIds = [result.value?.me, ...downlines].map((u) => u.userId);
  expandedKeys.value = userIds.reduce((result, userId) => {
    result[userId] = true;
    return result;
  }, {} as any);
}

function selectAccount(val: any) {
  emit("update:userId", val.data || val.result);
  goToAccount(val.data || val.result);
  toggleModal(false);
}

function toggleModal(val: boolean) {
  emit("input", val);
}

function goToAccount(userId: User["userId"]) {
  if (!route.name) {
    return;
  }
  router.push({
    name: route.name,
    query: { ...route.query, userId },
  });
}

return { __sfc: true,props, rootStore, $t, userId, route, router, searchInput, filterTerm, result, loading, expandedKeys, emit, accountNodes, collapseAll, expandAll, selectAccount, toggleModal, goToAccount }
}

})